import React, { useEffect, useState } from "react";

import "./ResultLocalSearch.css";
import pagnination from "./assets/google-pagintation.png";
import useLang from "../../i18n/useLang";
import content from "./content";

const ResultLocalSearch = ({ paramLinks }) => {
  const [link, setLink] = useState();
  const [isMaps, setIsMaps] = useState(false);
  const lang = useLang();
  const t = content[lang];
  const countryLabel =
    t.countries.find((country) => country.value === paramLinks.Country)
      ?.label || "";
  useEffect(() => {
    async function generateLink() {
      if (paramLinks.SearchType === "google") {
        setLink(
          `https://${t.googleDomain}/search?q=${paramLinks.SearchTerm}&gl=${paramLinks.Country}&hl=${t.hl}&gws_rd=cr&pws=0&uule=${paramLinks.Uule}`,
        );
        setIsMaps(false);
      } else {
        setLink(
          `https://${t.googleDomain}/search?q=${paramLinks.SearchTerm}&gl=${paramLinks.Country}&hl=${t.hl}&gws_rd=cr&pws=0&uule=${paramLinks.Uule}&tbm=lcl`,
        );
        setIsMaps(true);
      }
      console.log(paramLinks);
    }
    generateLink();
  }, []);

  return (
    <div className="container-search-links">
      <div className="title-results">
        {t.title}
      </div>
      <div className="subtitle-results">
        {t.subtitle}
      </div>
      <div className="links">
        <img src={pagnination} className="pagination-google" />
        <div className="pagination-links">
          <a href={link} className="link-page" target="_blank">
            1
          </a>
          <a
            href={`${link}&start=${isMaps ? "20" : "10"}`}
            className="link-page"
            target="_blank"
          >
            2
          </a>
          <a
            href={`${link}&start=${isMaps ? "40" : "20"}`}
            className="link-page"
            target="_blank"
          >
            3
          </a>
          <a
            href={`${link}&start=${isMaps ? "60" : "30"}`}
            className="link-page"
            target="_blank"
          >
            4
          </a>
          <a
            href={`${link}&start=${isMaps ? "80" : "40"}`}
            className="link-page"
            target="_blank"
          >
            5
          </a>
          <a
            href={`${link}&start=${isMaps ? "100" : "50"}`}
            className="link-page"
            target="_blank"
          >
            6
          </a>
          <a
            href={`${link}&start=${isMaps ? "120" : "60"}`}
            className="link-page"
            target="_blank"
          >
            7
          </a>
          <a
            href={`${link}&start=${isMaps ? "140" : "70"}`}
            className="link-page"
            target="_blank"
          >
            8
          </a>
          <a
            href={`${link}&start=${isMaps ? "160" : "80"}`}
            className="link-page"
            target="_blank"
          >
            9
          </a>
          <a
            href={`${link}&start=${isMaps ? "180" : "90"}`}
            className="link-page"
            target="_blank"
          >
            10
          </a>
        </div>
      </div>
      <br />
      <div className="subtitle-results">{t.summaryTitle}</div>
      <div className="search-summary">
        <table className="table-summary">
          <thead>
            <tr>
              <th>{t.query}</th>
              <th>{t.location}</th>
              <th>{t.country}</th>
              <th>{t.searchEngine}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{paramLinks.SearchTerm}</td>
              <td>{paramLinks.Location}</td>
              <td>
                {countryLabel}
              </td>
              <td>
                {paramLinks.SearchType === "google" ? t.googleSearch : t.googleMaps}
              </td>
            </tr>
          </tbody>
        </table>
        <ul className="summary-list">
          <li>
            {t.query}{t.colon}{" "}
            <span className="li-summary">{paramLinks.SearchTerm}</span>
          </li>
          <li>
            {t.location}{t.colon}
            <span className="li-summary">{paramLinks.Location}</span>
          </li>
          <li>
            {t.country}{t.colon}{" "}
            <span className="li-summary">
              {countryLabel}
            </span>
          </li>
          <li>
            {t.searchEngine}{t.colon}{" "}
            <span className="li-summary">
              {paramLinks.SearchType === "google" ? t.googleSearch : t.googleMaps}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ResultLocalSearch;
